// https://app.growthbook.io/features/prcng-1109_v1
export const EXPERIMENT_FLAG = 'prcng-1109_v1'

export type ExperimentBucket = 'control' | 'variant_1' | 'variant_2'
